import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import {FrapperService} from "./frapper.service";
import {AssignedService} from "./assigned.service";
import { AuthService } from '../auth/auth.service';

@Injectable({
  providedIn: 'root'
})
export class TribunalService {

  Doctype_tribunal ='Tribunal'
  // Doctype_Type_Demande ='type_de_demande'

  constructor(private http: HttpClient, private frapper: FrapperService,private authservice: AuthService, private assigneService:AssignedService) {}


 //all tribunals
  async getAllTribunals(filter =null) {
    try {
      let all_tribunals = await this.frapper.GetDoctypes(this.Doctype_tribunal,'["*"]',filter).toPromise()
      return all_tribunals
    } catch (error) {
      this.authservice.handleError(error)
    }

  }


  async getOneTribunal(name) {
    try {
      let tribunal = await this.frapper.GetDoctype(this.Doctype_tribunal,name,'["*"]',null).toPromise()
    //console.log('My Courriers Principale ===> ', my_courriers)
    return tribunal
    } catch (error) {
      this.authservice.handleError(error)
    }

  }

  async nouvelleTribunals(body) {
    try {
      let tribunal = await this.frapper.CreateDoctype(this.Doctype_tribunal,body).toPromise()
      return tribunal
    } catch (error) {
      this.authservice.handleError(error)
    }

  }

  async updateTribunal(docname,body){
    try {
      let result = this.frapper.UpdateDoctype(this.Doctype_tribunal,docname,body).toPromise()
      return result
    } catch (error) {
      this.authservice.handleError(error)
    }

  }

 

}
